import * as Models from ".";
export interface IRoleModel {
        roleId: string;
        name: string;
        description: string;
        groups: Array<Models.GroupModel.GroupModel>;
    }

    export class RoleModel implements IRoleModel {
        roleId: string;
        name: string;
        description: string;
        groups: Array<Models.GroupModel.GroupModel> = new Array<Models.GroupModel.GroupModel>();

        constructor(name: string) {
            this.name = name;
        }
    }